export type WhiteBoardSizes = '640-560' | '512-640' | '640-640' | '640-720' | '672-1008';

interface WhiteBoardSizePresetValues {
  width: number;
  height: number;
}

type WhiteBoardSize = { [key in WhiteBoardSizes]: WhiteBoardSizePresetValues };

export const WHITE_BOARD_SIZE_PRESET: WhiteBoardSize = {
  '640-560': { width: 640, height: 560 },
  '512-640': { width: 512, height: 640 },
  '640-640': { width: 640, height: 640 },
  '640-720': { width: 640, height: 720 },
  '672-1008': { width: 672, height: 1008 },
};
